import React, { useEffect, useMemo } from 'react';
import { useMatch } from 'react-router-dom';

import { Heading, HStack, Link, Spacer } from '@chakra-ui/react';

import { selectCourseProperties } from '../../api/selectors';
import { useAppSelector } from '../../store/hooks';

interface Props {
	right?: React.ReactNode;
}

const NavBar: React.FC<Props> = (props) => {
	const { right } = props;
	/**
	 * Do not use `useUrlParams` or `useParams` here as it won't work
	 * (since NavBar isn't a child of the Course route component)
	 */
	const match = useMatch('/courses/:courseId');
	const courseProperties = useAppSelector((state) =>
		selectCourseProperties(state, Number(match?.params.courseId))
	);
	const title = useMemo(
		() =>
			`Manage Due Dates${
				courseProperties ? `: ${courseProperties.number} ${courseProperties.name}` : ''
			}`,
		[courseProperties]
	);

	useEffect(() => {
		if (courseProperties?.number) {
			document.title = `Manage Due Dates: ${courseProperties.number} | Soomo`;
		}
	}, [courseProperties]);

	return (
		<HStack
			height="52px"
			background="background.500"
			borderColor="border.100"
			borderBottomWidth="1px"
			align="center"
			spacing={0}>
			<Link
				display="flex"
				height="51px"
				px="31px"
				alignItems="center"
				color="#000"
				fontSize="16px"
				fontWeight={500}
				href={`${import.meta.env.VITE_API_BASE}/courses/${match?.params.courseId}`}
				background="background.600"
				transition="none"
				textDecoration="none"
				_hover={{
					color: '#fff',
					background: '#5F01DF'
				}}>
				Back to webtext
			</Link>
			<Heading as="h1" fontSize="21px" fontWeight={700} pl="34px">
				{title}
			</Heading>
			<Spacer />
			{right}
		</HStack>
	);
};

export default NavBar;
